import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TS_EditableItemComponentProto } from '@nu-art/thunderstorm-frontend/components/TS_EditableItemComponent/TS_EditableItemComponent';
import { _className, LL_H_C, LL_V_L, ModuleFE_BrowserHistory, SimpleListAdapter, TS_Card, TS_DropDown, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { Component_SmartExpressionEditor } from '../../../../expression-smart-editor/Component_SmartExpressionEditor.js';
import './Editor_TopExpression.scss';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
import { Expression_OutputTypes, ExpressionType_Deduction } from '@app/hcs-shared/expression';
import React from 'react';
export class Editor_TopExpression extends TS_EditableItemComponentProto {
    cardRef = React.createRef();
    resizeObserver;
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.context = ModuleFE_BrowserHistory.getQueryParameter('type');
        // In case there's no output dropdown make the editor a bit larger
        const cardWidth = state.context === 'pathways' ? 600 : 400;
        state.cardWidth ??= cardWidth;
        state.viewMode = nextProps.viewMode;
        return state;
    }
    componentDidMount() {
        // observe changes in editor card size in order to resize it correctly
        if (this.cardRef.current) {
            this.resizeObserver = new ResizeObserver((entries) => {
                this.setState({ cardWidth: entries[0].contentRect.width });
            });
            this.resizeObserver.observe(this.cardRef.current);
        }
    }
    componentWillUnmount() {
        if (this.resizeObserver)
            this.resizeObserver.disconnect();
    }
    renderExpressionEditorTitle = () => {
        return _jsx(LL_V_L, { className: 'editor-title-container', children: "E:" });
    };
    getOutputTypeDropDown = () => {
        const outputTypeAdapter = SimpleListAdapter(Expression_OutputTypes, (item) => _jsx(_Fragment, { children: item.item }));
        const mandatoryProps_outputType = {
            placeholder: 'Select output type',
            caret: this.props.viewMode ? undefined : DropDown_DefaultCaret,
            adapter: outputTypeAdapter
        };
        return TS_DropDown.prepare(mandatoryProps_outputType);
    };
    renderOutputTypeDropdown = () => {
        if (this.state.context === 'pathway' || this.state.editable.item.expressionType === ExpressionType_Deduction.dbKey)
            return '';
        const DropDown_ExpressionOutputTypes = this.getOutputTypeDropDown();
        return _jsx(DropDown_ExpressionOutputTypes.editable, { editable: this.state.editable, prop: 'outputType', disabled: this.props.viewMode, onSelected: async (value) => {
                await this.state.editable.update('outputType', value);
            }, showErrorTooltip: true });
    };
    render() {
        const className = _className('expression-card', 'top-expression', this.props.hideCards && 'hide-card');
        const expressionEditable = this.state.editable;
        return _jsx(TS_Card, { className: className, innerRef: this.cardRef, children: _jsx(TS_PropRenderer.Horizontal, { label: this.renderExpressionEditorTitle(), children: _jsxs(LL_H_C, { className: 'match_parent', children: [this.renderOutputTypeDropdown(), _jsx(Component_SmartExpressionEditor, { height: 30, disabled: this.state.viewMode, width: this.state.cardWidth, hideButtons: true, value: expressionEditable.item.expression ?? '', onEditorBlur: async (value) => {
                                await expressionEditable.update('expression', value);
                                this.forceUpdate();
                            } })] }) }) });
    }
}
//# sourceMappingURL=Editor_TopExpression.js.map